export default [{
  path: '/ExhibitorDetail',//参展收获
  name: 'ExhibitorPage',
  
  meta: {
    title: '参展收获_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/Exhibitor/ExhibitorDetail.vue')
},{
  path: '/ExhibitorPlan',//展馆规划 展区规划
  name: 'planPage',
  meta: {
    title: '展区规划_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/Exhibitor/plan.vue')
},{
  path: '/ExhibitorProgram',//参展程序
  name: 'programPage',
  meta: {
    title: '参展程序_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/Exhibitor/program.vue')
},{
  path: '/ExhibitorBooth',//网上报名参展  网上申请展位
  name: 'BoothPage',
  meta: {
    title: '网上报名参展_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/Exhibitor/booth.vue')
},{
  path: '/ExhibitorGuide',//展位申请指引
  name: 'guidePage',
  meta: {
    title: '展位申请指引_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/Exhibitor/guide.vue')
},{
  path: '/ExhibitorSchedule',//展览日程安排
  name: 'schedulePage',
  meta: {
    title: '展览日程安排_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/Exhibitor/schedule.vue')
},{
  path: '/ExhibitorPrice',//展位价格
  name: 'pricePage',
  meta: {
    title: '展位价格_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/price.vue')
},{
  path: '/ExhibitorRecommend',//推荐布展商
  name: 'recommendPage',
  meta: {
    title: '推荐布展商_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/Exhibitor/pdf.vue')
},]




// WEBPACK FOOTER //
// ./src/router/Exhibitor.js